import React, { useState, useEffect } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import { AdminWsProvider } from './context/AdminWsContext';
import { MainLayout, visibleNavItems } from './components/MainLayout';
import { Overview } from './views/Overview';
import { Devices } from './views/Devices';
import { Orders } from './views/Orders';
import { Stats } from './views/Stats';
import { Settings } from './views/Settings';
import { Login } from './views/Login';
import { MapView } from './views/Map';
import { Technicians } from './views/Technicians';
import { DebugLogs } from './views/DebugLogs';
import { Sessions } from './views/Sessions';
import { Profiles } from './views/Profiles';
import { ServerConsole } from './views/ServerConsole';

const DashboardContent = () => {
  const { isAuthenticated, authChecked, token, relayUrl, isAdmin, can } = useAuth();
  const [activeTab, setActiveTab] = useState('overview');

  // Профиль может не иметь права на «Обзор» — стартуем с первого доступного
  // раздела; и если текущий таб стал недоступен (сменились права) — уводим.
  useEffect(() => {
    if (!isAuthenticated) return;
    const allowed = visibleNavItems(isAdmin, can).map(i => i.id);
    if (allowed.length > 0 && !allowed.includes(activeTab)) {
      setActiveTab(allowed[0]);
    }
  }, [isAuthenticated, isAdmin, can, activeTab]);

  if (!authChecked) {
    return (
      <div className="spinner-wrap">
        <div className="spinner" />
      </div>
    );
  }

  if (!isAuthenticated) return <Login />;

  return (
    <AdminWsProvider token={token} relayUrl={relayUrl}>
      <MainLayout activeTab={activeTab} setTab={setActiveTab}>
        {activeTab === 'overview'  && <Overview />}
        {activeTab === 'devices'   && <Devices />}
        {activeTab === 'orders'    && <Orders />}
        {activeTab === 'stats'     && <Stats />}
        {activeTab === 'settings'  && <Settings />}
        {activeTab === 'map'          && <MapView />}
        {activeTab === 'profiles'     && <Profiles />}
        {activeTab === 'technicians'  && <Technicians />}
        {activeTab === 'debug-logs'   && <DebugLogs />}
        {activeTab === 'sessions'     && <Sessions />}
        {activeTab === 'console'      && <ServerConsole />}
      </MainLayout>
    </AdminWsProvider>
  );
};

function App() {
  return (
    <AuthProvider>
      <DashboardContent />
    </AuthProvider>
  );
}

export default App;
